import { UpcomingMatchesSchema } from '@/views/sports/UpcomingMatches/styles/UpcomingMatches.styles';

export const upcomingMatchesStyles: UpcomingMatchesSchema = {
  pageHeader: {
    fontSize: 'xl',
    fontFamily: 'CarterOne',
    fontWeight: 'normal',
    textTransform: 'uppercase',
    textShadow: '0px 3px 4px rgba(0, 0, 0, 0.25)',
  },
  stackWrapper: {
    color: 'white',
    mt: ['-1', null, '0', '-2'],
    py: ['2', null, null, '4'],
    pl: ['2', '0', null, '4'],
    pr: ['3', '0', null, '4'],
  },
  boxWrapper: {
    alignItems: 'center',
    display: [null, null, null, 'flex'],
    justifyContent: 'space-between',
  },
  sortByText: {
    fontSize: '2xs',
    fontWeight: 'bold',
    textTransform: 'uppercase',
  },
  scrollButtonGroup: {
    variant: 'filter',
    bg: 'none',
    maxH: '9',
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
    borderColor: 'blackAlpha.400',
    borderRadius: 'none',
    boxShadow: '0 1px rgba(255, 255, 255, .07)',
    pb: '2',
    pos: 'relative',
  },
  flexRenderSortingMobile: {
    justify: 'flex-end',
  },
  loadingSkeletonText: {
    my: '4',
    noOfLines: 2,
    spacing: '4',
    skeletonHeight: '2',
  },
  mainStackWrapper: {
    spacing: '4',
  },
  mainStackInner: {
    spacing: '4',
  },
  heading: {
    alignItems: 'center',
    display: 'flex',
    fontSize: 'sm',
    gap: '1',
    textTransform: 'uppercase',
    fontWeight: 'normal',
    fontFamily: 'CarterOne',
    textShadow: '0px 3px 4px rgba(0, 0, 0, 0.25)',
  },
  headingIcon: {
    color: 'beta.500',
    sx: {},
  },
  propositionButton: {
    flex: '1',
    height: '38px',
  },
  boxSportWrapper: {
    borderColor: 'delta.300',
    borderWidth: '1px',
    h: '100%',
  },
  buttonSport: {
    borderColor: 'beta.500',
    color: 'white',
    _active: {
      bg: 'beta.500',
      borderColor: 'beta.500',
      color: 'beta.800',
      '&:after': {
        display: 'none',
      },
    },
  },
  buttonAllSports: {
    _active: {
      bg: 'beta.500',
      borderColor: 'beta.500',
      color: 'beta.800',
      '&:after': {
        display: 'none',
      },
    },
  },
};
